import {
    ADD_DINING_LOCATION,
    ADD_DINING_LOCATION_ERROR,
    ADD_DINING_LOCATION_SUCCESS,
    DELETE_DINING_LOCATION,
    DELETE_DINING_LOCATION_ERROR,
    DELETE_DINING_LOCATION_SUCCESS,
    DINING_LOCATION,
    DINING_LOCATION_ERROR,
    DINING_LOCATION_SUCCESS,
    UPDATE_DINING_LOCATION,
    UPDATE_DINING_LOCATION_ERROR,
    UPDATE_DINING_LOCATION_SUCCESS
} from "../constants/diningLocationConstants";


const initialState = {
    loading: false,
    success: false,
    diningLocationData:[],
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};


function diningLocationReducer(state = initialState, action) {
    switch (action.type) {
        case DINING_LOCATION:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DINING LOCATIONS',
                'loadingMessage': 'THE DINING LOCATION ARE BEING LOADED',
                'type': action.type

            });
        case DINING_LOCATION_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'diningLocationData': [],
                'type': action.type
            });
        case DINING_LOCATION_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'diningLocationData': action.data,
                'type': action.type

            });
        case ADD_DINING_LOCATION:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DINING LOCATION',
                'loadingMessage': 'THE DINING LOCATION IS BEING SAVED',
                'type': action.type
            });
        case ADD_DINING_LOCATION_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case ADD_DINING_LOCATION_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'diningLocationData': state.diningLocationData? [...state.diningLocationData, action.data].sort((a, b)=>{
                    let x = a.name.toLowerCase();
                    let y = b.name.toLowerCase();
                    if (x < y) {return -1;}
                    if (x > y) {return 1;}
                    return 0;
                  }): [],
                'type': action.type
            });
        case UPDATE_DINING_LOCATION:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DINING LOCATION',
                'loadingMessage': 'THE DINING LOCATION IS BEING UPDATED',
                'type': action.type
            });
        case UPDATE_DINING_LOCATION_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case UPDATE_DINING_LOCATION_SUCCESS:

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'diningLocationData': state.diningLocationData? state.diningLocationData.map((item) => (item._id === action.data._id ? action.data : item )) : [],
                'type': action.type
            });
        case DELETE_DINING_LOCATION:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'DINING LOCATION',
                'loadingMessage': 'THE DINING LOCATION IS BEING DELETED',
                'type': action.type
            });
        case DELETE_DINING_LOCATION_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case DELETE_DINING_LOCATION_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'diningLocationData': (state.diningLocationData) ? state.diningLocationData.filter(item => item._id !== action.data) : [],
                'type': action.type
            });
        default:
            return state;
    }
};

export default diningLocationReducer